import { render, staticRenderFns } from "./programManagement.vue?vue&type=template&id=3cb9e960&scoped=true"
import script from "./programManagement.vue?vue&type=script&lang=js"
export * from "./programManagement.vue?vue&type=script&lang=js"
import style0 from "./programManagement.vue?vue&type=style&index=0&id=3cb9e960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9e960",
  null
  
)

export default component.exports